module.exports = __webpack_public_path__ + "img/italy-tuberculosis-male.50ba55e7.png";